<template>
<div>
    <div id="hd">
        <div class="wp">
            <div class="logo">
                <router-link to="index"  >
                <a href="javascript:;" @click='menu_change(0)'>
                    <img src="../assets/xzlogo2.png" alt="" style="height:50px">
                </a>
                </router-link>
            </div>
            <div id="nav">
                <ul>
                    <router-link to="zhyy"><li><a @click='menu_change(1)' :class="{'mycur':changeNav==1}">智慧运营</a></li></router-link>

                    <router-link to="zhfk"><li><a @click='menu_change(2)' :class="{'mycur':changeNav==2}">智慧风控</a></li></router-link>

                    <router-link to="zhjc"><li><a @click='menu_change(3)' :class="{'mycur':changeNav==3}">智慧决策</a></li></router-link>

                    <router-link to="zwyth"><li><a @click='menu_change(8)' :class="{'mycur':changeNav==8}">政务一体化</a></li></router-link>

                    <router-link to="jstx"><li><a @click='menu_change(4)' :class="{'mycur':changeNav==4}">技术体系</a></li></router-link>

                    <router-link to="khal"><li><a @click='menu_change(5)' :class="{'mycur':changeNav==5}">典型案例</a></li></router-link>

                    <router-link to="xwdt"><li><a @click='menu_change(6)' :class="{'mycur':changeNav==6}">行业动态</a></li></router-link>

                    <router-link to="lxwm"><li><a @click='menu_change(7)' :class="{'mycur':changeNav==7}">关于我们</a></li></router-link>

                </ul>
            </div>
            <div class="tel">138-8913-9023</div>
        </div>
    </div>
    <!-- end #hd -->
    <div class="c"></div>
    <div id="m-hd"> <a href="/122/" class="m-logo"><img src="../assets/xzlogo.png" alt=""></a>
        <div class="m-trigger"></div>
        <ul class="m-nav">
            <router-link to="/"><li><a href="default.html" class="v1">首页 </a></li></router-link>

            <router-link to="zhyy"><li><a @click='menu_change(1)' :class="{'mycur':changeNav==1}">智慧运营</a></li></router-link>

            <router-link to="zhfk"><li><a @click='menu_change(2)' :class="{'mycur':changeNav==2}">智慧风控</a></li></router-link>

            <router-link to="zhjc"><li><a @click='menu_change(3)' :class="{'mycur':changeNav==3}">智慧决策</a></li></router-link>

            <router-link to="zhjc"><li><a @click='menu_change(8)' :class="{'mycur':changeNav==8}">政务一体化</a></li></router-link>

            <router-link to="jstx"><li><a @click='menu_change(4)' :class="{'mycur':changeNav==4}">技术体系</a></li></router-link>

            <router-link to="khal"><li><a @click='menu_change(5)' :class="{'mycur':changeNav==5}">典型案例</a></li></router-link>

            <router-link to="xwdt"><li><a @click='menu_change(6)' :class="{'mycur':changeNav==6}">行业动态</a></li></router-link>

            <router-link to="lxwm"><li><a @click='menu_change(7)' :class="{'mycur':changeNav==7}">关于我们</a></li></router-link>

        </ul>
    </div>
    <router-view></router-view>
     <div class="c"></div>
    <!-- begin #fd --> 
    <div id="fd" class="index-fd pr">
        <div class="map-bg3"></div>
        <div class="wp">
            <div class="fd-top">
                <dl>
                    <dt>关于我们</dt>
                    <dd>
                        <ul class="ul-fd">
                            <router-link :to="{name:'lxwm',params:{id:'wmss'}}" ><li @click='menu_change(7)'>我们是谁</li></router-link>
                            <router-link :to="{name:'lxwm',params:{id:'zscq'}}" ><li @click='menu_change(7)'>知识产权</li></router-link>
                            <router-link :to="{name:'lxwm',params:{id:'lxwm'}}" ><li @click='menu_change(7)'>联系我们</li></router-link>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>智慧运营</dt>
                    <dd>
                        <ul class="ul-fd">
                            <router-link :to="{name:'zhyy',params:{id:'hxyw'}}"><li @click='menu_change(1)'>核心业务</li></router-link>
                            <router-link :to="{name:'zhyy',params:{id:'zhfw'}}"><li @click='menu_change(1)'>综合服务</li></router-link>
                            <router-link :to="{name:'zhyy',params:{id:'zhgl'}}"><li @click='menu_change(1)'>综合管理</li></router-link>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>智慧风控</dt>
                    <dd>
                        <ul class="ul-fd">

                            <router-link :to="{name:'zhfk',params:{id:'ydfx'}}"><li @click='menu_change(2)'>一道防线</li></router-link>

                            <router-link :to="{name:'zhfk',params:{id:'edfx'}}"><li @click='menu_change(2)'>二道防线</li></router-link>

                            <router-link :to="{name:'zhfk',params:{id:'sdfx'}}"><li @click='menu_change(2)'>三道防线</li></router-link>

                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>智慧决策</dt>
                    <dd>
                        <ul class="ul-fd">

                            <router-link :to="{name:'zhjc',params:{id:'sjck'}}"><li @click='menu_change(3)'>数据仓库解决方案</li></router-link>

                            <router-link :to="{name:'zhjc',params:{id:'ldjsc'}}"><li @click='menu_change(3)'>领导驾驶舱</li></router-link>

                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>政务一体化</dt>
                    <dd>
                        <ul class="ul-fd">

                            <router-link :to="{name:'zwyth',params:{id:'tysfrz'}}"><li @click='menu_change(8)'>统一身份认证</li></router-link>

                            <router-link :to="{name:'zwyth',params:{id:'zwfwhcp'}}"><li @click='menu_change(8)'>政务服务"好差评"</li></router-link>

                            <router-link :to="{name:'zwyth',params:{id:'dzpj'}}"><li @click='menu_change(8)'>电子(印章)票据</li></router-link>
                        </ul>
                    </dd>
                </dl>
                <dl>
                    <dt>微信公众号</dt>
                    <dd class="pr">
                        <img style="width:80px;margin-top:-10px;" src="../assets/Images/qrcode.jpg">
                    </dd>
                    <dt>咨询电话</dt>
                    <dd class="pr">
                        <p class="tel">13889139023</p>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="fd-copy">
            <div class="wp">
                <p> <span style="color:#CCCCCC;">Copyright &copy; 2022-2042 版权所有</span>　<img src="../assets/Images/beian.png"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202000997" target="_blank"><span style="color:#CCCCCC;">辽公网安备 21011202000997号</span></a> 
               <span style="color:#CCCCCC;"></span>　<a href="https://beian.miit.gov.cn" target="_blank"><span style="color:#CCCCCC;">辽ICP备2022005785号-4</span></a> </p>
            </div>
        </div>
    </div>
    <div class="side2">
        <ul>
            <!-- <li><a href=""><img src="../assets/Picture/r_icon1.png" alt=""></a>
                <div class="weixin" ><em></em><img src="../assets/Picture/ewm.png" alt=""></div>
            </li> -->
            <li><a @click="goTop()" class="sidetop"><img src="../assets/Picture/r_icon2.png"></a></li>
        </ul>
    </div>   
</div>
</template>

<script>
    //import { goTop } from "../assets/Scripts/lib.js";
    export default {
        name: "",
        data() {
            return {
            };
        },
        computed:{
            changeNav(){
                return this.$store.getters.changeNav
               // return this.$store.getters.changeNav;
            }
        },
        mounted(){
            switch(this.$route.path){
                case '/zhyy':
                    this. menu_change(1);break;
                case '/zhfk':
                    this. menu_change(2);break;
                case '/zhjc':
                    this. menu_change(3);break;
                case '/jstx':
                    this. menu_change(4);break;
                case '/khal':
                    this. menu_change(5);break;
                case '/xwdt':
                    this. menu_change(6);break;
                case '/lxwm':
                    this. menu_change(7);break;
                case '/zwyth':
                    this. menu_change(8);break;
                default:
                    this. menu_change(0);break;
            }
            $('.side2 li').hover(function () {
                $(this).find('.weixin').stop().slideToggle();
            })

        },methods:{
            menu_change(index){
                this.$store.dispatch('getNavbar',index) 
                //this.flag = index;
            },
            goTop(){
                 $('body,html').animate({scrollTop:0},500);
            }
        },
        watch: {
            $route(to, from) {
                //console.log("this.$route.path");
                //console.log(this.$route.path);
            }
        },
        
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ul-fd {
    color: #a8a8af;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue